import { render, staticRenderFns } from "./PageErrorNotAuthorized.vue?vue&type=template&id=102a6836"
import script from "./PageErrorNotAuthorized.vue?vue&type=script&lang=js"
export * from "./PageErrorNotAuthorized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports